import { useTranslation } from 'react-i18next';
import { useContentSuggestions, useProfilePathways } from '../../../hooks';
import React, { useEffect, useState } from 'react';
import { CredentialSearchbar, NoItemView, PathwaysBox } from '../../../components';
import './PathwaysViewContent.css';
import { inIframe } from '../../../utils';
import { NavLink } from 'react-router-dom';
import { useDebounce } from '../../../hooks/useDebounce';

interface PathwaysViewContentProps {
  username: string;
}

export const PathwaysViewContent: React.FC<PathwaysViewContentProps> = ({
  username,
}) => {
  const { userPathways, userPathwaysLoaded } = useProfilePathways(username);
  const {
    content, contentLoaded
  } = useContentSuggestions('pathway', username)
  const { t } = useTranslation('library');
  const PATHWAY_TAB = "pathway"
  const ASSIGNMENT_TAB = "assignment"
  const [currentTab, setCurrentTab] = useState(PATHWAY_TAB)
  const [assignmentPathways, setAssignmentPathways] = useState<any[]>([])
  const [pathwaySearchTerm, setPathwaySearchTerm] = useState<string>('')
  const [assignedPathwaySearchTerm, setAssignedPathwaySearchTerm] = useState<string>('')
  const [filteredPathways, setFilteredPathways] = useState<any[]>([])
  const [filteredAssignedPathways, setFilteredAssignedPathways] = useState<any[]>([])

  useDebounce(()=>{
    if(contentLoaded && content){
      const _assignedPathways = content?.results?.map((pathway)=>({
        ...pathway,
        name:pathway?.pathway_name
      })) ?? []
      setAssignmentPathways(_assignedPathways)
      setFilteredAssignedPathways(_assignedPathways)
    }
  }, 200, [contentLoaded, content])

  useDebounce(()=>{
    if(userPathwaysLoaded && userPathways.length > 0){
      setFilteredPathways(userPathways)
    }
  }, 200, [userPathwaysLoaded, userPathways])

  useDebounce(()=>{
    if(pathwaySearchTerm.length > 2){
      setFilteredPathways(userPathways.filter((pathway) =>String(pathway?.name).toUpperCase().includes(String(pathwaySearchTerm).toUpperCase())))
    }else{
      setFilteredPathways(userPathways)
    }
  }, 200, [pathwaySearchTerm])

  useDebounce(()=>{
    if(assignedPathwaySearchTerm.length > 1){
      setFilteredAssignedPathways(assignmentPathways.filter((pathway) =>String(pathway?.name).toUpperCase().includes(String(assignedPathwaySearchTerm).toUpperCase())))
    }else{
      setFilteredAssignedPathways(assignmentPathways)
    }
  }, 200, [assignedPathwaySearchTerm])

  return (
    <span>
      <div
        className="ov_panel active with-custom-tab"
        data-name="p"
        style={{ marginTop: '20px' }}
      >
        <div className="br_cont" style={{padding:'0px'}}>
          <div className="div-block-421" style={{marginBottom:"20px"}}>
              <div className="profile_menu">
                <div onClick={() => setCurrentTab(PATHWAY_TAB)} className={`prof_menu first ${currentTab === PATHWAY_TAB ? "active" : ""}`}>
                  {t('My pathways')}
                </div>
                <div onClick={() => setCurrentTab(ASSIGNMENT_TAB)} className={`prof_menu first ${currentTab === ASSIGNMENT_TAB ? "active" : ""}`}>
                  {t('Assigned pathways')}
                </div>
              </div>
            </div>
          {
            currentTab===PATHWAY_TAB ? (
              <div className="br_row">
                  <CredentialSearchbar
                    searchTerm={pathwaySearchTerm}
                    setSearchTerm={setPathwaySearchTerm}
                    title={t('Pathways')}
                    recordCount={Array.isArray(filteredPathways) ? filteredPathways.length : 0}
                  ></CredentialSearchbar>
                <PathwaysBox
                  userPathways={filteredPathways}
                  userPathwaysLoaded={userPathwaysLoaded}
                  username={username}
                  showProgressBar={true}
                ></PathwaysBox>

                {userPathways?.length === 0 && userPathwaysLoaded && inIframe() && (
                  <NoItemView
                    displayMessage={`${username} ${t(
                      "hasn't created any pathways yet."
                    )}`}
                    imageUrl={'/images/tools.png'}
                    displayPadding={true}
                  />
                )}
              </div>
            ) : (
              <div className="br_row">
                  <CredentialSearchbar
                    searchTerm={assignedPathwaySearchTerm}
                    setSearchTerm={setAssignedPathwaySearchTerm}
                    title={t('Assigned Pathways')}
                    recordCount={Array.isArray(filteredAssignedPathways) ? filteredAssignedPathways.length : 0}
                  ></CredentialSearchbar>
                <PathwaysBox
                  userPathways={filteredAssignedPathways}
                  userPathwaysLoaded={contentLoaded}
                  username={username}
                  isAssignedPathway={true}
                  showProgressBar={true}
                ></PathwaysBox>

                {assignmentPathways?.length === 0 && contentLoaded && (
                  <NoItemView
                    displayMessage={ inIframe() ? `${username} ${t(
                      "hasn't been assigned to a pathway yet."
                    )}` : `You haven't been assigned to a programs yet.`}
                    imageUrl={'/images/tools.png'}
                    displayPadding={true}
                  />
                )}
              </div>
            )
          }
          
        </div>
      </div>
    </span>
  );
};
